import { useEffect, useState } from 'react';
import { CustomerFormData } from '../types';
import { validateEmailFormat } from '../utils/validationUtils';

interface UseCustomerValidationProps {
  formData: CustomerFormData;
  originalData: {
    name: string;
    phone: string;
    alternativephone: string;
    email: string;
    address: string;
    address2: string;
    address3: string;
  };
}

export const useCustomerValidation = ({ formData, originalData }: UseCustomerValidationProps) => {
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    const isDataChanged = 
      formData.name !== originalData.name ||
      formData.phoneNumber !== originalData.phone ||
      formData.alternativePhone !== originalData.alternativephone ||
      formData.email !== originalData.email ||
      formData.address1 !== originalData.address ||
      formData.address2 !== originalData.address2 ||
      formData.address3 !== originalData.address3;

    const hasRequiredFields = 
      formData.phoneNumber.length >= 8 && 
      formData.name.trim() !== "" && 
      (formData.email === "" || validateEmailFormat(formData.email));

    setIsFormValid(isDataChanged && hasRequiredFields);
  }, [formData, originalData]);

  const validateForm = async () => {
    if (!formData.name.trim() || !formData.phoneNumber.trim()) {
      return false;
    }

    if (formData.email.trim() !== "" && !validateEmailFormat(formData.email)) {
      return false;
    }

    return true;
  };

  return {
    validateForm,
    isFormValid
  };
};